import { twMerge } from "tailwind-merge"
import { slides } from "../../../constants/content"
import ImagePane from "../../home/hero/ImagePane"
import GoogleCollab from "./GoogleCollab"
import Spreadsheet from "./Spreadsheet"
import SpreadsheetDropdown from "./SpreadsheetDropdown"

function Use() {
  // Use slide is at index 3
  const useSlideIndex = 3
  const useSlide = slides[useSlideIndex]

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div
        className={twMerge(
          "rounded-[25px]",
          "shadow-[0_0_20px_10px_theme(colors.neutral[900]/0.15)] md:shadow-[0_0_40px_10px_theme(colors.neutral[900]/0.15)] lg:shadow-[0_0_150px_20px_theme(colors.neutral[900]/0.15)]",
          "dark:shadow-[0_0_20px_10px_#0d0d0d] dark:md:shadow-[0_0_40px_10px_#0d0d0d] dark:lg:shadow-[0_0_150px_20px_#0d0d0d]",
        )}
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <ImagePane
          currentSlideIndex={useSlideIndex}
          containerStyle={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: useSlide.accentColor,
          }}
          imageStyle={{
            backgroundPosition: "top -100px left -335px",
          }}
        />
        <Spreadsheet
          style={{
            position: "absolute",
            left: "16px",
            top: "16px",
            zIndex: 1,
          }}
        />
        <GoogleCollab
          style={{
            position: "absolute",
            left: "294px",
            top: "-70px",
            zIndex: 1,
          }}
        />
        <SpreadsheetDropdown
          style={{
            position: "absolute",
            left: "57px",
            top: "90px",
            zIndex: 2,
          }}
        />
      </div>
    </div>
  )
}

export default Use
